export type {
  Align,
  TableColumns,
  BasicTableProps,
  FilterProps,
  PaginationProps,
  TableColumnScope,
} from './types';

import type { App } from 'vue';
import Table from './src/table';

export const BasicTable = Object.assign(Table, {
  install: function (app: App) {
    app.component(Table.name, Table);
  },
});

export default BasicTable;
